import { useEffect, useState, memo } from 'react';

import { CloseCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';

const RedEnvelopeRainStyle = styled.div`
  position: relative;
  width: 90vw;
  height: 90vh;
  .low-opacity {
    animation: 4s low-opacity 2s forwards;
  }
  .float-ele {
    position: absolute;
    top: -220px;
    animation: run ease-in infinite;
  }
  .star-ele {
    position: absolute;
    top: -120px;
    animation: run ease-in-out infinite;
    z-index: 11;
    background: #fffeff;
    box-shadow: 0px 0px 15px 7px rgba(255, 231, 143, 0.5);
    filter: blur(1px);
  }

  @keyframes run {
    0% {
      transform: translateY(0) translateX(0);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    80% {
      opacity: 0.5;
    }
    100% {
      transform: translateY(120vh) translateX(-10vw);
      opacity: 0;
    }
  }
  @keyframes low-opacity {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.8;
    }
  }

  .gift-bag-wrap {
    perspective: 1000px; /* 给容器添加透视效果 */
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 567px;
    height: 345px;
    z-index: 12;
    &.isExpandDialog {
      width: 831px;
      &.blue .gift-bag-ele .gift-bag .gift-bag-back {
        width: 100%;
        height: 100%;
      }
    }
    &.isYX {
      width: 294px;
      height: 411px;
      .gift-bag-ele {
        .gift-bag {
          width: 294px;
          height: 361px;
          .gift-bag-front {
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v2/dl.png') center center
              no-repeat;
            cursor: pointer;
          }
          .gift-bag-back {
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v2/dl3.png') center center
              no-repeat;
            transform: rotateY(180deg);
          }
        }
      }
    }
    &.blue {
      width: 831px;
      @keyframes pulse {
        0% {
          opacity: 0.5;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0.5;
        }
      }
      .gift-bag-ele {
        .gift-bag {
          .gift-bag-front {
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v3/redEnvelope2.png')
              center center no-repeat;
            background-size: cover;
          }
          .gift-bag-back {
            width: 676px;
            height: 487px;
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v5/coupon-wrap-blue.png')
              center center no-repeat;
            background-size: cover;
          }
        }
      }
      .gdfl {
        width: 190px;
        text-align: center;
        height: 42px;
        border-radius: 22px;
        font-weight: bold;
        font-size: 16px;
        line-height: 42px;
        display: inline-block;
        margin-top: 40px;
        background: linear-gradient(180deg, #fff7ef 0%, #ffe4cc 100%);
        color: #e17411;
      }
    }
    .gift-bag-ele {
      width: 100%;
      height: 100%;
      animation:
        gift-bag-in-top 1.1s ease-in-out 0s 1 forwards,
        gift-bag-bob-float 0.3s ease-out 1.1s 1 forwards,
        gift-bag-bob 1.5s ease-in-out 1.4s infinite alternate;
      .gift-bag {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        transform-style: preserve-3d; /* 保留3D转换效果 */
        transition: transform 0.6s; /* 添加过渡效果 */
        &.rotate-y {
          transform: rotateY(180deg);
        }
        .gift-bag-face {
          position: absolute;
          backface-visibility: hidden;
        }
        .gift-bag-front {
          width: 245px;
          height: 320px;
          background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v4/redEnvelope-f.png')
            center center no-repeat;
          background-size: contain;
          cursor: pointer;
        }
        .gift-bag-back {
          width: 100%;
          height: 100%;
          background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v4/redEnvelope-result.png')
            center center no-repeat;
          background-size: contain;
          transform: rotateY(180deg);
          &.not-bg {
            background: none;
          }
          .gift-coupon-item {
            padding-top: 31px;
            width: 160px;
            height: 105px;
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v3/redEnvelope-coupon.svg')
              center center no-repeat;
            &.big-bg {
              width: 198px;
              height: 105px;
              background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v3/redEnvelope-coupon-2.svg')
                center center no-repeat;
            }
          }
        }
      }
    }
  }

  @keyframes gift-bag-in-top {
    0% {
      transform: translateY(-50vh);
      animation-timing-function: ease-in;
      opacity: 0;
    }
    38% {
      transform: translateY(0);
      animation-timing-function: ease-out;
      opacity: 1;
    }
    55% {
      transform: translateY(-65px);
      animation-timing-function: ease-in;
    }
    72% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
    81% {
      transform: translateY(-28px);
      animation-timing-function: ease-in;
    }
    90% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
    95% {
      transform: translateY(-8px);
      animation-timing-function: ease-in;
    }
    100% {
      transform: translateY(0);
      animation-timing-function: ease-out;
    }
  }

  @keyframes gift-bag-bob-float {
    100% {
      transform: translateY(0);
    }
  }

  @keyframes gift-bag-bob {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
  }
`;

let tid;

const AmountDom = ({ giftBagData }) => {
  let content;

  if (giftBagData.isFreeExpress) {
    content = <span className="text-[34px] font-bold">包邮</span>;
  } else if (giftBagData.couponType === 'discount') {
    content = (
      <>
        <span className="inline-block text-[34px] font-bold">{Math.floor(giftBagData.couponDiscount * 10) / 10}</span>
        <span className="ml-[3px] inline-block text-[20px] font-normal">折</span>
      </>
    );
  } else {
    content = (
      <>
        <span className="text-[25px]">￥</span>
        <span className="h-[34px] text-[34px] font-bold">{giftBagData.couponAmount}</span>
      </>
    );
  }
  return <p className="fonts mb-[4px] leading-[1]">{content}</p>;
};

let errMsgId;
// 膨胀券弹窗样式组件
const ModalRedEnvelopeWrap = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  padding: 24px;
  border-radius: 12px;
  width: 831px;
  height: 638px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  &.blue-theme {
    &::after {
      background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v5/bg-light.png') no-repeat
        center / cover;
    }
    .modal-redenvelope-wrap-content {
      // 蓝色主题
      background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v5/coupon-wrap-blue-expand.png')
        no-repeat center / cover;
      .expand-coupons {
        .coupon-b {
          .flag {
            background: #5b9cff;
          }
          color: #fff;
          background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v5/b-coupon.png') no-repeat
            center / cover;
        }
        .coupon-s {
          .cp-amount,
          .cp-threshold,
          .unit {
            color: #4587f2;
          }
          &::after {
            background: url('https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v5/pz-icon.png') no-repeat
              center / cover;
          }
          .flag {
            background: #5b9cff;
          }
        }
      }
      .cp-effective {
        color: #4587f2;
      }
    }
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('https://static.szlcsc.com/ecp/assets/web/page/activity/temp25ssy/red-pack/bg-light.png') no-repeat
      center / cover;
    animation: pulse 2s infinite;
    z-index: -1;
    transform: scale(1.3);
  }

  .modal-redenvelope-wrap-content {
    width: 676px;
    height: 487px;
    background: url('https://static.szlcsc.com/ecp/assets/web/page/activity/temp25ssy/red-pack/coupon-wrap.png')
      no-repeat center / cover;
    text-align: center;

    .red-envelope-expand-modal-close-btn {
      position: absolute;
      right: 50%;
      transform: translateX(calc(-50% + 30px));
      bottom: 32px;
      width: 30px;
      height: 30px;
      color: #fff;
      cursor: pointer;
      background: url('https://static.szlcsc.com/ecp/assets/web/page/activity/temp25ssy/red-pack/close-btn.svg')
        no-repeat center / cover;
    }

    .expand-coupons {
      margin-top: 140px;
      margin-left: 142px;
      display: flex;
      align-items: center;

      .coupon-s {
        position: relative;
        margin-right: 48px;
        width: 160px;
        height: 106px;
        background: url('https://static.szlcsc.com/ecp/assets/web/page/activity/temp25ssy/red-pack/coupon.png')
          no-repeat center / cover;

        &::after {
          content: '';
          position: absolute;
          top: 46px;
          right: -36px;
          width: 25px;
          height: 25px;
          background: url('https://static.szlcsc.com/ecp/assets/web/page/activity/temp25ssy/red-pack/pz-icon.png')
            no-repeat center / cover;
        }

        .flag {
          width: 65px;
          height: 23px;
          line-height: 23px;
          background: #ff5f5f;
          border-radius: 10px 0px 10px 0px;
          font-size: 14px;
          color: #ffffff;
        }

        .cp-amount {
          margin-top: 20px;
          font-size: 34px;
          color: #fd3f39;
          font-weight: bold;
          line-height: 46px;
        }

        .unit {
          font-size: 24px;
          color: #fd3f39;
          position: relative;
          top: -3px;
        }

        .cp-threshold {
          font-size: 16px;
          color: #fd3f39;
          line-height: 21px;
        }
      }

      .coupon-b {
        width: 206px;
        height: 138px;
        background: url('https://static.szlcsc.com/ecp/assets/web/page/activity/temp25ssy/red-pack/b-coupon.png')
          no-repeat center / cover;

        .flag {
          width: 84px;
          height: 30px;
          line-height: 30px;
          background: #ff5f5f;
          border-radius: 13px 0px 13px 0px;
          font-size: 14px;
          color: #ffffff;
        }

        .cp-amount {
          margin-top: 20px;
          font-size: 44px;
          color: #fff;
          font-weight: bold;
          line-height: 58px;
        }

        .unit {
          font-size: 32px;
          color: #fff;
          font-weight: bold;
          position: relative;
          top: -4px;
        }

        .cp-threshold {
          font-size: 20px;
          color: #fff;
          line-height: 26px;
        }
      }
    }

    .cp-effective {
      margin-top: 14px;
      font-size: 14px;
      color: #fe2475;
      line-height: 19px;
    }
    .gdfl {
      width: 190px;
      height: 42px;
      background: linear-gradient(180deg, #fbf6d8 0%, #fbe9a9 100%);
      border-radius: 22px;
      font-weight: bold;
      font-size: 16px;
      color: #fd3f39;
      line-height: 42px;
      display: inline-block;
      margin-top: 40px;
    }

    @keyframes pulse {
      0% {
        opacity: 0.2;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0.2;
      }
    }
  }
`;

// 红包前面按钮组件
const RedEnvelopeFront = ({ theme, drawGift }) => {
  if (theme === 'red') {
    return (
      <button className="gift-bag-face gift-bag-front h-full w-full relative text-[#FFEA97]" onClick={drawGift}>
        <p className="absolute left-[50%] top-[25px] w-full translate-x-[-50%] text-[18px] font-[400] ">
          11.11&nbsp;年终盛典
        </p>
        <p className="absolute left-[50%] top-[62px] w-full translate-x-[-50%] text-[25px] font-bold">5-1111元满减券</p>
      </button>
    );
  }

  return <button className="gift-bag-face gift-bag-front h-full w-full" onClick={drawGift} />;
};

// 膨胀券内容组件
const ExpandedCouponContent = ({ giftBagData, theme }) => (
  <ModalRedEnvelopeWrap className={`${theme === 'blue' ? 'blue-theme' : ''}`}>
    <div className="modal-redenvelope-wrap-content">
      <div className="expand-coupons">
        {giftBagData &&
          giftBagData
            .sort((a) => (a.isExpand ? 1 : -1))
            .map((cc, index) => (
              <div key={index} className={(cc.isExpand ? 'coupon-b' : 'coupon-s') + ' text-center'}>
                <p className="flag ellipsis" title={cc.couponTypeName}>
                  {cc.couponTypeName}
                </p>

                {cc.couponType === 'discount' ? (
                  <>
                    <span className="cp-amount">{cc.couponDiscount}</span>
                    <span className="unit">折</span>
                  </>
                ) : (cc.couponType === 'freight' && cc.isFreeExpress) ||
                  (cc.couponType === 'mro_freight' && cc.isFreeExpress) ? (
                  <span className="cp-amount">包邮</span>
                ) : (
                  <>
                    <span className="unit">¥</span>
                    <span className="cp-amount">{cc.couponAmount}</span>
                  </>
                )}

                <p className="cp-threshold">
                  {cc.isOrderActualMoney ? '实付满' : '满'}
                  {cc.minOrderMoney}可用
                </p>
              </div>
            ))}
      </div>

      {/* 有效期 */}
      {giftBagData[0]?.useBeginTime && giftBagData[0]?.useEndTime && (
        <p className="cp-effective text-center">
          有效期{giftBagData[0].useBeginTime}至{giftBagData[0].useEndTime}
        </p>
      )}
      <a
        data-spm="ldy"
        href={Domains.lcscActivityUrl + (theme === 'blue' ? '/super.html' : '/25ssy.html')}
        target="_blank"
        title={theme === 'blue' ? '立创商城-超级会员日-落地页' : '立创商城-25年双十一落地页'}
        className="gdfl"
      >
        更多福利
      </a>
    </div>
  </ModalRedEnvelopeWrap>
);

// 普通券内容组件 - 元宵版本
const YuanXiaoNormalCouponContent = ({ giftBagData, lenWidth }) => (
  <>
    <p className="leading-1 w-full text-[30px] font-bold text-white">恭喜您抽中</p>
    <div className={`mx-auto flex items-center justify-between ${lenWidth}`}>
      {giftBagData &&
        giftBagData.length &&
        giftBagData.map((t, k) => (
          <div
            key={k}
            className={`gift-coupon-item relative ${giftBagData.length < 3 ? 'big-bg' : ''} text-[#FD3F39] mt-[35px]`}
          >
            <p
              className="absolute left-0 top-0 text-center text-[14px] leading-[23px] text-[#fff] bg-[#FD3F39] h-[23px] w-[65px] truncate rounded-br-[10px] rounded-tl-[10px] px-[4px]"
              title={t.couponTypeName}
            >
              {t.couponTypeName}
            </p>
            <AmountDom giftBagData={t}></AmountDom>
            <p className="fonts text-[16px]">
              {t.isOrderActualMoney ? '实付满' : '满'}
              {t.minOrderMoney}元可用
            </p>
          </div>
        ))}
    </div>
    {giftBagData[0]?.useBeginTime && giftBagData[0]?.useEndTime && (
      <div className="mt-[14px] text-[14px] text-[#4F5359]">
        有效期{giftBagData[0].useBeginTime}至{giftBagData[0].useEndTime}
      </div>
    )}
    <a
      data-spm="ldy"
      href={Domains.lcscActivityUrl + '/super.html'}
      target="_blank"
      title="立创商城-超级会员日-落地页"
      className="mt-[62px] block w-full text-[18px] text-white"
    >
      更多福利
    </a>
  </>
);

// 普通券内容组件 - 红色主题
const RedThemeNormalCouponContent = ({ giftBagData, lenWidth }) => (
  <>
    <div className={`mx-auto flex items-center justify-between ${lenWidth}`}>
      {giftBagData &&
        giftBagData.length &&
        giftBagData.map((t, k) => (
          <div key={k} className={`gift-coupon-item relative ${giftBagData.length < 3 ? 'big-bg' : ''} text-[#FD3F39]`}>
            <p
              className="absolute left-0 top-0 text-center text-[14px] leading-[23px] text-[#fff] bg-[#FD3F39] h-[23px] w-[65px] truncate rounded-br-[10px] rounded-tl-[10px] px-[4px]"
              title={t.couponTypeName}
            >
              {t.couponTypeName}
            </p>
            <AmountDom giftBagData={t}></AmountDom>
            <p className="fonts text-[16px]">
              {t.isOrderActualMoney ? '实付满' : '满'}
              {t.minOrderMoney}元可用
            </p>
          </div>
        ))}
    </div>
    {giftBagData[0]?.useBeginTime && giftBagData[0]?.useEndTime && (
      <div className="mt-[14px] text-[14px] text-[#4F5359]">
        有效期{giftBagData[0].useBeginTime}至{giftBagData[0].useEndTime}
      </div>
    )}
    <BottomLink theme="red" />
  </>
);

// 普通券内容组件 - 蓝色主题
const BlueThemeNormalCouponContent = ({ giftBagData, lenWidth, ml }) => (
  <>
    <div className={`flex items-center justify-between ${ml} ${lenWidth}`}>
      {giftBagData &&
        giftBagData.length &&
        giftBagData.map((t, k) => (
          <div key={k} className={`gift-coupon-item relative ${giftBagData.length < 3 ? 'big-bg' : ''} text-[#4587F2]`}>
            <p
              className="absolute left-0 top-0 text-center text-[14px] leading-[23px] text-[#fff] bg-[#4587F2] h-[23px] w-[65px] truncate rounded-br-[10px] rounded-tl-[10px] px-[4px]"
              title={t.couponTypeName}
            >
              {t.couponTypeName}
            </p>
            <AmountDom giftBagData={t}></AmountDom>
            <p className="fonts text-[16px]">
              {t.isOrderActualMoney ? '实付满' : '满'}
              {t.minOrderMoney}元可用
            </p>
          </div>
        ))}
    </div>
    {giftBagData[0]?.useBeginTime && giftBagData[0]?.useEndTime && (
      <div className="mt-[14px] text-[14px] text-[#4587F2]">
        有效期{giftBagData[0].useBeginTime}至{giftBagData[0].useEndTime}
      </div>
    )}
    <BottomLink theme="blue" />
  </>
);

// 底部链接组件
const BottomLink = ({ theme }) => {
  if (theme === 'blue') {
    return (
      <a
        data-spm="ldy"
        href={Domains.lcscActivityUrl + '/super.html'}
        target="_blank"
        title="立创商城-超级会员日-落地页"
        className="gdfl"
      >
        更多福利
      </a>
    );
  }
  return (
    <a
      data-spm="ldy"
      href={Domains.lcscActivityUrl + '/25ssy.html'}
      target="_blank"
      title="立创商城-25年双十一落地页"
      className="absolute bottom-[30px] left-[50%] h-[30px] w-[50%] translate-x-[-50%]"
    ></a>
  );
};

const DrawRedEnvelope = ({ closeRain, uuid, theme, isYuanXiao }) => {
  const [giftBagData, setGiftBagData] = useState(false); // 是否打开了券包
  const [errorMsg, setErrorMsg] = useState(null); // 错误提示
  const [isExpandCoupon, setIsExpandCoupon] = useState(false); // 是否是膨胀券

  function drawGift() {
    sendAxios({
      method: 'get',
      url: '/async/red/packet/draw',
      params: { uuid },
      baseURL: Domains.lcscActivityUrl,
    }).then(async (res) => {
      if (res.needLogin) {
        Utils.showWindowLogin();
        setErrorMsg('请登陆后操作！');
        return;
      }
      if (res.code === 200 && res.result) {
        const couponItems = res.result?.couponItems || [];

        // 检查是否有膨胀券
        const expandedCoupon = couponItems.some((item) => item.isExpand);
        setIsExpandCoupon(expandedCoupon);
        setGiftBagData(couponItems);
      } else {
        setErrorMsg(res.msg || '请重试~');
        errMsgId = setTimeout(() => {
          setErrorMsg(null);
          clearTimeout(errMsgId);
        }, 3000);
      }
    });
  }

  const lenWidth = () => {
    if (giftBagData?.length === 3) {
      return 'w-[496px]';
    } else if (giftBagData?.length === 2) {
      return 'w-[426px]';
    } else {
      return 'w-[198px]';
    }
  };

  const blueLenMl = () => {
    // 蓝色主题
    if (giftBagData?.length === 3) {
      return 'ml-[101px]';
    } else if (giftBagData?.length === 2) {
      return 'ml-[140px]';
    } else {
      return 'ml-[240px]';
    }
  };

  const renderNormalCouponContent = () => {
    if (isYuanXiao) {
      return <YuanXiaoNormalCouponContent giftBagData={giftBagData} lenWidth={lenWidth()} />;
    } else if (theme === 'red') {
      return <RedThemeNormalCouponContent giftBagData={giftBagData} lenWidth={lenWidth()} />;
    } else {
      return <BlueThemeNormalCouponContent giftBagData={giftBagData} ml={blueLenMl()} lenWidth={lenWidth()} />;
    }
  };

  const getBackPaddingTop = () => {
    if (isYuanXiao) return 'pt-[94px]';
    if (theme === 'red') return 'pt-[100px]';
    return 'pt-[170px]';
  };

  return (
    <section
      className={`gift-bag-wrap relative ${isYuanXiao ? 'isYX' : ''} ${isExpandCoupon ? 'isExpandDialog' : ''} ${theme}`}
      data-spm="hby"
    >
      <section
        className={`absolute left-[50%] top-[-160px] z-[1] flex translate-x-[-50%] rounded-[5px] bg-white px-0 py-0 text-center text-[14px] opacity-0 shadow-lg ${errorMsg && 'top-[-200px] px-[10px] py-[5px] opacity-100'} transition-all duration-300`}
      >
        {errorMsg && <CloseCircleOutlined className="mr-[5px] text-[red]" />}
        {errorMsg && <span className="whitespace-nowrap text-nowrap text-[14px]">{errorMsg}</span>}
      </section>
      <div className="gift-bag-ele">
        <section className={`gift-bag ${giftBagData ? 'rotate-y' : ''}`}>
          <RedEnvelopeFront theme={theme} drawGift={drawGift} />
          <section
            className={`gift-bag-face gift-bag-back h-full w-full text-center ${getBackPaddingTop()} ${isExpandCoupon ? 'not-bg' : ''}`}
          >
            {isExpandCoupon ? (
              <ExpandedCouponContent giftBagData={giftBagData} theme={theme} />
            ) : (
              renderNormalCouponContent()
            )}
          </section>
        </section>
      </div>
      <button
        className="absolute bottom-[-40px] left-[50%] h-[30px] w-[30px] translate-x-[-50%]"
        style={{
          background: `url(https://static.szlcsc.com/ecp/assets/newWeb/modal/close-btn.svg) center center no-repeat`,
          backgroundSize: 'cover',
        }}
        onClick={closeRain}
      ></button>
    </section>
  );
};

// 红包雨动画元素组件
const RedEnvelopeElements = ({ maxLeft, theme, isYuanXiao }) => {
  const redEnvelopeList = Array.from(new Array(20)); // 红包数量

  const getRedEnvelopeImage = () => {
    if (isYuanXiao) {
      return 'https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v2/dl2.png';
    }
    return theme === 'blue'
      ? 'https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v3/redEnvelope.png'
      : 'https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v4/redEnvelope.png';
  };

  return (
    <>
      {redEnvelopeList.map((_, index) => (
        <img
          className={`float-ele z-[13] mx-auto ${isYuanXiao ? 'w-[61px]' : 'w-[102px]'}`}
          src={getRedEnvelopeImage()}
          alt="红包"
          key={index}
          style={{
            left: `${Math.random() * maxLeft}px`,
            animationDuration: `${Math.random() * 2 + 3}s`,
            animationDelay: `${Math.random() * 5}s`,
          }}
          loading="lazy"
          decoding="async"
        />
      ))}
    </>
  );
};

// 流星动画元素组件
const MeteorElements = ({ maxLeft }) => {
  const lxList = Array.from(new Array(3)); // 流星数量

  return (
    <>
      {lxList.map((_, index) => (
        <img
          className="float-ele z-[12] h-[78px] w-[46px]"
          alt="流星"
          src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/lx.svg"
          style={{
            left: `${Math.random() * maxLeft}px`,
            animationDuration: `${Math.random() * 2 + 2}s`,
          }}
          key={index}
        />
      ))}
    </>
  );
};

// 元宵特效元素组件
const YuanXiaoEffectElements = ({ maxLeft }) => {
  const lx2List = Array.from(new Array(15)); // 元宝数量

  return (
    <>
      {lx2List.map((_, index) => (
        <img
          className="float-ele z-[13] h-[29px] w-[39px]"
          alt="元宝"
          src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/v2/lx3.png"
          style={{
            left: `${Math.random() * maxLeft}px`,
            animationDuration: `${Math.random() + 2}s`,
          }}
          key={index}
        />
      ))}
    </>
  );
};

// 普通特效元素组件
const NormalEffectElements = ({ maxLeft }) => {
  const lx2List = Array.from(new Array(3)); // 流星2数量
  const lx3List = Array.from(new Array(9)); // 星星数量

  return (
    <>
      {lx2List.map((_, index) => (
        <img
          className="float-ele z-[11] h-[78px] w-[46px]"
          alt="流星"
          src="https://static.szlcsc.com/ecp/assets/newWeb/www/home/redEnvelope/lx2.svg"
          style={{
            left: `${Math.random() * maxLeft}px`,
            animationDuration: `${Math.random() + 2}s`,
          }}
          key={index}
        />
      ))}
      {lx3List.map((_, index) => (
        <section
          className="star-ele"
          style={{
            width: `${Math.round(Math.random() * 8)}px`,
            height: `${Math.round(Math.random() * 8)}px`,
            left: `${Math.random() * maxLeft}px`,
            animationDuration: `${Math.random() * 8 + 2}s`,
          }}
          key={index}
        ></section>
      ))}
    </>
  );
};

const RedEnvelopeRain = memo(({ theme, isYuanXiao }) => {
  const [maxLeft, setMaxLeft] = useState(0); // 红包覆盖的最大宽度范围

  useEffect(() => {
    setMaxLeft(1200);
  }, []);

  return (
    <section className={`low-opacity relative mx-auto h-full w-[1200px]`}>
      <RedEnvelopeElements maxLeft={maxLeft} theme={theme} isYuanXiao={isYuanXiao} />
      <MeteorElements maxLeft={maxLeft} />
      {isYuanXiao ? <YuanXiaoEffectElements maxLeft={maxLeft} /> : <NormalEffectElements maxLeft={maxLeft} />}
    </section>
  );
});
RedEnvelopeRain.displayName = 'RedEnvelopeRain';

const RedEnvelopeRainPop = ({ onClose, uuid, theme, isYuanXiao }) => {
  const [showRain, setShowRain] = useState(true); // 是否展示红包雨
  const [showGiftBag, setShowGiftBag] = useState(false); // 是否展示券包

  useEffect(() => {
    tid = setTimeout(() => {
      setShowGiftBag(true);
    }, 1000);
    return () => {
      clearTimeout(tid);
    };
  }, []);

  function closeRain() {
    setShowRain(false);
    setShowGiftBag(false);
    onClose();
  }

  return (
    <RedEnvelopeRainStyle>
      {showRain && <RedEnvelopeRain theme={theme} isYuanXiao={isYuanXiao}></RedEnvelopeRain>}
      {showGiftBag && <DrawRedEnvelope theme={theme} isYuanXiao={isYuanXiao} closeRain={closeRain} uuid={uuid} />}
    </RedEnvelopeRainStyle>
  );
};

export default RedEnvelopeRainPop;
